// import usePaystackScript from './paystack-script';
import { useMutation } from "@apollo/client";
import { MakeExternalPayment, MakeExternalPaymentVariables } from "_graphql/mutation/__generated__/MakeExternalPayment";
import { returnCheckoutLink } from "_graphql/mutation/payment";


export default function usePaystackPayment() {
  // const { userInfo } = useAppSelector(state => state.auth);
  // const { firstName, lastName, billingEmail, phone, amount } = options;

  const [initializePayment, { loading, data, error }] = useMutation<
    MakeExternalPayment,
    MakeExternalPaymentVariables
  >(returnCheckoutLink);

  // function initializePayment(): void {
  //   execute({
  //     variables: {
  //       data: {
  //         customer_email: billingEmail ?? "",
  //         customer_first_name: firstName ?? "",
  //         customer_last_name: lastName ?? "",
  //         phone: phone ?? "",
  //         request_amount: amount,
  //         reasonForPayment: ReasonForPayment.OrderPurchase,
  //         secret: generateRandomAlphanumeric(10),
  //         user_id: userInfo?.id ?? "",
  //       },
  //     },
  //   });
  // }
  return { initializePayment, loading, error, checkoutLink: data?.makeExternalPayment };
}
